import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue'
import { directUpload, getUploadConfig } from "@/request/common";
import { getToken } from '@/api';
// 定义props

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  config: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props, { expose: __expose }) {

const props = __props
// 合并配置
const uploadConfig = computed(() => ({
  ...props.config
}))

const baseApi = process.env.VUE_APP_API_BASE_URL;
const headers = {
  Authorization: getToken(),
};

const handleCustomUpload = async (option) => {
  const uploadConfigRes = await getUploadConfig(option.file)

  const { code: uploadConfigCode, data: uploadConfigData } = uploadConfigRes.data
  if (uploadConfigCode !== 200) return Promise.reject(uploadConfigRes.data.msg)
  const { presignedUrl, url, fileId: id } = uploadConfigData
  const uploadRes = await directUpload(presignedUrl, option.file)
  return {
    code: uploadRes.status,
    data: {
      ...uploadRes.data,
      url: url,
      id,
      originalFilename: option.file.name,
      file: option.file
    },
  }
}

let directUploaderRef = ref(null)
// 触发文件选择
const triggerFileSelect = () => {
  if (directUploaderRef.value) {
    // @ts-ignore
    directUploaderRef.value.click()
  }
}
// 暴露方法供外部使用
__expose({
  triggerFileSelect
})

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createBlock(_component_el_upload, _mergeProps({
    class: "direct-uploader",
    ref_key: "directUploaderRef",
    ref: directUploaderRef
  }, uploadConfig.value, _toHandlers(_ctx.$attrs), {
    action: `${_unref(baseApi)}/common/upload/directUpload`,
    "http-request": handleCustomUpload,
    headers: headers
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["action"]))
}
}

})